import { render, staticRenderFns } from "./appointmentList.vue?vue&type=template&id=81a33bb2&scoped=true&"
import script from "./appointmentList.vue?vue&type=script&lang=js&"
export * from "./appointmentList.vue?vue&type=script&lang=js&"
import style0 from "./appointmentList.vue?vue&type=style&index=0&id=81a33bb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a33bb2",
  null
  
)

component.options.__file = "appointmentList.vue"
export default component.exports